<template>
  <v-container>
    <page-heading>{{ pageTitle }}</page-heading>

    <object-groups-table
      sortable
    />
  </v-container>
</template>

<script>
import PageHeading from '../components/PageHeading';
import {RouterUtils} from '../utils/router-utils';
import {LocaleUtils} from '../utils/locale-utils';
import {MainUtils} from '../utils/main-utils';
import ObjectGroupsTable from '../components/ObjectGroupsTable';

export default {
  name: 'ObjectGroupsSortPage',
  mixins: [
    MainUtils,
    RouterUtils,
    LocaleUtils
  ],
  components: {
    ObjectGroupsTable,
    PageHeading
  },
  computed: {
    pageTitle () {
      return this.transPlural('objectGroup.sortObjectGroups')
    }
  }
}
</script>

<style>

</style>
